import { Stack, Typography } from '@mui/material'
import { ITruckVisitItem } from '@planning/rt-stores/truckVisit/TruckVisitItem'
import { useTranslate } from '@tolgee/react'
import { ColoredLabel, EmptyIndicator } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'

interface Props {
  truckVisit: ITruckVisitItem
}
export const TruckVisitDriver = observer(({ truckVisit }: Props) => {
  const { t } = useTranslate()
  return (
    <Stack>
      <Stack direction='row' alignItems='center' gap={1}>
        <Typography variant='subtitle2'>
          {truckVisit.driver ? truckVisit.driver.data.name : EmptyIndicator}
        </Typography>
        {truckVisit.driver?.data.banned && (
          <ColoredLabel color='warning' label={t('banned', 'Banned')} />
        )}
      </Stack>

      <Typography variant='caption'>
        {truckVisit.driver ? truckVisit.driver.data.driverID : EmptyIndicator}
      </Typography>
    </Stack>
  )
})
